import { render, staticRenderFns } from "./ClosestHairColorBar.vue?vue&type=template&id=cd74b5b0&scoped=true&lang=pug"
import script from "./ClosestHairColorBar.vue?vue&type=script&lang=js"
export * from "./ClosestHairColorBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd74b5b0",
  null
  
)

export default component.exports